import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useThemeColor } from "./useThemeColor.js";
const AddCircleIcon = forwardRef(
  ({ backgroundColor: propBackgroundColor = "transparent", ...props }, ref) => {
    const getColor = useThemeColor();
    const backgroundColor = getColor(propBackgroundColor);
    return /* @__PURE__ */ jsx(SvgIcon, { ...props, ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25.469", height: "25.469", viewBox: "0 0 25.469 25.469", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 13122", children: [
      /* @__PURE__ */ jsxs("g", { "data-name": "Path 14724", fill: backgroundColor, children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.734 24.519a11.707 11.707 0 0 1-8.332-3.452A11.707 11.707 0 0 1 .95 12.734c0-3.147 1.226-6.107 3.452-8.332A11.707 11.707 0 0 1 12.734.95c3.148 0 6.107 1.226 8.333 3.452a11.707 11.707 0 0 1 3.452 8.332c0 3.148-1.226 6.107-3.452 8.333a11.707 11.707 0 0 1-8.333 3.452z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.734 1.9a10.763 10.763 0 0 0-7.66 3.173A10.763 10.763 0 0 0 1.9 12.734c0 2.894 1.127 5.615 3.173 7.661a10.763 10.763 0 0 0 7.661 3.174c2.894 0 5.615-1.127 7.661-3.174a10.763 10.763 0 0 0 3.174-7.66c0-2.895-1.127-5.615-3.174-7.662a10.763 10.763 0 0 0-7.66-3.173m0-1.9c7.032 0 12.734 5.701 12.734 12.734S19.767 25.47 12.734 25.47C5.701 25.469 0 19.767 0 12.734 0 5.701 5.701 0 12.734 0z",
            fill: backgroundColor,
            stroke: "none"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("g", { "data-name": "Group 9009", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 9008", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            "data-name": "Line 112",
            transform: "translate(6.914 12.677)",
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeWidth: "2px",
            d: "M0 0h11.755"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            "data-name": "Line 113",
            transform: "translate(12.791 6.8)",
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeWidth: "2px",
            d: "M0 0v11.755"
          }
        )
      ] }) })
    ] }) }) });
  }
);
export {
  AddCircleIcon
};
//# sourceMappingURL=AddCircleIcon.js.map
